/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { Loader } from '@zeeve-platform/loader-component';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import CardAllNetwork from './nodeCard';
import BreadCrumb from './BreadCrumbComponent';
import RightButtons from './ButtonsComponent';
import Urls from '../../utils/urls';

import { prefixPath } from '../../utils/helpers';
import apiBackendInstance from '../../utils/axios';

export interface subscriptionDataInterface {

  protocol_name: string,
  plan_code: string,
  strictly_present_attributes:string[],
  attributes: {
    addon_code: string,
    attribute_name: string,
    selection_type: string,
    }[],
  total_quantity: number,
  available_quantity: number,
  redirection_url: string
}

const NodeBody = ({ theme }: { theme: string }) => {
  const [nodeConfigurationData, setNodeConfigurationData] = useState<subscriptionDataInterface[]>([]);
  const [showLoader, setShowLoader] = useState(false);

  const loaderUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);

  useEffect(() => {
    let isActive = true;
    setShowLoader(true);
    apiBackendInstance.get(Urls.getNodeConfiguration(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (isActive && response && response.data && response.data.data) {
        setNodeConfigurationData(response.data.data);
      }
      setShowLoader(false);
    }).catch(() => {
      setNodeConfigurationData([]);
      setShowLoader(false);
    });

    return () => { isActive = false; };
  }, []);
  const imgSubPath = window.location.origin;
  const addIconImg = imgSubPath + prefixPath(`/img/${theme}/add-icon.png`);
  const from = localStorage.getItem('from') || '';
  const path_one = localStorage.getItem('workspaceName') || '';
  const path_url = localStorage.getItem('workspace_url') || '';
  const workspacePath = [{ name: 'Workspaces', path: prefixPath('/workspace') }, { name: path_one, path: prefixPath(`/workspace/${path_url}`) }];
  const fullNodePath = [{ name: 'Home', path: prefixPath('/dashboard') }, { name: 'Networks', path: prefixPath('/allNetwork') }];
  const validaorNodePath = [{ name: 'Home', path: prefixPath('/dashboard') }, { name: 'Networks', path: prefixPath('/network/staking-nodes') }];

  return (
    <>
        <section className="px-5 col-12 workspace">
            <div className="cardBlack">
              <div className="row mt-4 pt-1">
                  <BreadCrumb breadcrumbURI="Configure Your Nodes/" />
                  <RightButtons theme={theme} />
                  <div className="col-lg-6 pt-2 mt-2 col-xl-6 col-sm-12 col-xs-12">
                    <p className="fs-7">
                    {from === 'workspace' ? (
                      <Breadcrumb prefixLink={workspacePath} activeLink="Add Network" />
                    ) : (
                      <p> </p>
                    )}

                    {from === 'validatornode' ? (
                      <Breadcrumb prefixLink={validaorNodePath} activeLink="Add Network" />
                    ) : (
                      <p> </p>
                    )}

                    {from === 'fullnode' ? (
                      <Breadcrumb prefixLink={fullNodePath} activeLink="Add Network" />
                    ) : (
                      <p> </p>
                    )}
                    </p>
                  </div>
                  <div className="mt-2 row" style={{ minHeight: '400px' }}>
                      {
                          nodeConfigurationData.map((o, idx) => (
                                  <CardAllNetwork
                                      key={`${idx.toString()}subcard`}
                                      totalNodes={o.total_quantity}
                                      planCode={o.plan_code}
                                      availableNodes={o.available_quantity}
                                      fixAttributes={o.strictly_present_attributes}
                                      attributes={o.attributes}
                                      frontend_base_suburl={o.redirection_url}
                                      protocolName={o.protocol_name}
                                      cardType="public"
                                  />
                          ))
                      }
                      {theme === 'zeeve' && (
                      <>
                      <CardAllNetwork
                        key="corda"
                        totalNodes={0}
                        planCode="corda"
                        availableNodes={0}
                        fixAttributes={['BYOC-AWS', 'Node / Notary / NMS Node Types', 'Monitoring & Analytics Enabled']}
                        attributes={[]}
                        frontend_base_suburl={Urls.getCordaUrl()}
                        protocolName="Corda"
                        cardType="permissive"
                      />
                      <CardAllNetwork
                        key="corda"
                        totalNodes={0}
                        planCode="corda"
                        availableNodes={0}
                        fixAttributes={['BYOC-AWS', 'Node / Notary / CENM Node Types', 'Monitoring & Analytics Enabled']}
                        attributes={[]}
                        frontend_base_suburl={Urls.getCordaEnterpriseUrl()}
                        protocolName="Corda Enterprise"
                        cardType="permissive"
                      />
                      </>
                      )}
                      <div className="col-lg-4 col-xl-3 col-md-5 col-sm-12 mt-5 cursor mg-auto">
                          <div className="workSpaceCard cursor " style={{ height: '100%' }}>
                              <a href={Urls.getSelectProtocolUrl()} style={{ textDecoration: 'none' }}>
                                  <div className="card-body text-center add-workspace">
                                      <div className="mt-4 mx-auto">
                                      <img className="mt-2 mb-3" src={addIconImg} alt="" />
                                      </div>
                                      <h6 className="mt-2 activeTextColor">Buy Subscription</h6>
                                      <p>
                                         Purchase nodes for your blockchain protocol
                                      </p>
                                  </div>
                              </a>
                          </div>
                      </div>
                  </div>
                  {showLoader && <Loader imagePath={loaderUrl} />}
              </div>
            </div>

        </section>

    </>
  );
};

export default NodeBody;
